<div class="container">
  <app-promo-banner class="rise-on-hover" type="home"></app-promo-banner>

  <!-- States Picker -->
  <lib-picker-slider
    *ngIf="homePageService.stateItems.length > 0"
    class="picker-slider"
    [initialSelect]="false"
    [canBeDeselected]="true"
    [items]="homePageService.stateItems"
    [selectedItem]="homePageService.selectedState"
    [colorScheme]="colorScheme"
    (onSelect)="onSelectedStateChange($event)"
    (onDeselect)="onSelectedStateChange(null)">
  </lib-picker-slider>

  <div class="spinner-container" *ngIf="loading">
    <mat-spinner strokeWidth="2" color="{{colorScheme.accent}}" diameter="54" class="m-auto"></mat-spinner>
  </div>

  <div *ngIf="!loading" class="content fade-in">

    <!-- Main Section -->
    <lib-match-section
      moreButtonRouterLink="/spiele/heute"
      moreButtonTitle="Mehr Spiele"
      itemLinkPath="ticker"
      [layout]="matchesMinimalLayout"
      [live]="true"
      [matches]="homePageService.topEvents"
    ></lib-match-section>
    <app-promo-banner
      *ngIf="promoService.registrationUserFunnel?.promoBanner && showRegisterBanner()"
      class="d-block d-md-none"
      [banner]="promoService.registrationUserFunnel.promoBanner"
      [openRegistration]="true"
    ></app-promo-banner>
    <lib-news-section
      [newsList]="homePageService.topNews"
      [layout]="newsMixedLayout">
    </lib-news-section>
    <lib-ad class="ad"></lib-ad>
    <lib-match-section
      title="Livestreams"
      titleIcon="play_circle"
      moreButtonRouterLink="/videos/livestreams/"
      moreButtonTitle="Mehr Livestreams"
      [live]="true"
      [matches]="homePageService.livestreams"
    ></lib-match-section>
    <lib-news-section
      title="Aus dem Studio"
      titleIcon="smart_display"
      moreButtonRouterLink="/news"
      moreButtonTitle="Mehr News"
      [newsList]="homePageService.studioNews"
      [layout]="newsRowThumbnailLayout">
    </lib-news-section>
    <lib-match-section
      title="Nachschauen"
      titleIcon="replay"
      moreButtonRouterLink="/videos/replays/"
      moreButtonTitle="Mehr Replays"
      [matches]="homePageService.replays"
    ></lib-match-section>
    <lib-abo-banner
      *ngIf="!homePageService.selectedState"
      [user]="userService.currentUser">
    </lib-abo-banner>
    <lib-news-section
      title="Aktuelles"
      titleIcon="newspaper"
      moreButtonRouterLink="/news"
      moreButtonTitle="Mehr News"
      [newsList]="homePageService.otherNews"
      [layout]="newsRowLayout">
    </lib-news-section>
    <!-- Ad Campaigns, waiting for placements in BE -->
    <!--lib-ad-sponsor-banner--
      *ngIf="homePageService.selectedState"
      [entityId]="homePageService.selectedState?.objectId"
      [entityType]="EntityType.State"
      [hideHeader]="true"
      [alwaysShow]="true">
    </lib-ad-sponsor-banner-->
    <!-- Abo Banner -->

    <!-- Shop Section -->
    <lib-shop-section
      id="shop-section"
      [shopItems]="shopService.shopItems">
    </lib-shop-section>

    <!-- Handball Section -->
    <lib-match-section
      *ngIf="!homePageService.selectedState"
      id="handball-section"
      title="Handball"
      titleIcon="sports_handball"
      moreButtonRouterLink="/hla"
      moreButtonTitle="Mehr zur HLA"
      [matches]="homePageService.handballMatches"
      [sportType]="handballType"
    ></lib-match-section>

    <!-- Specials Section -->
    <lib-specials-section
      id="specials-section"
      title="Im Fokus"
      titleIcon="star"
      [specials]="homePageService.specials">
    </lib-specials-section>
    <lib-ad class="ad"></lib-ad>

    <!-- Past Events Section -->
    <lib-match-section
      id="past-events-section"
      title="Spiele"
      titleIcon="sports_soccer"
      moreButtonRouterLink="/spiele"
      moreButtonTitle="Mehr Spiele"
      itemLinkPath="liveticker"
      [layout]="matchesMinimalLayout"
      [live]="true"
      [matches]="homePageService.pastEvents"
    ></lib-match-section>

    <!-- Favourites Section -->
    <lib-filter-section
      *ngIf="!homePageService.selectedState"
      id="favourites-section"
      title="Favoriten"
      titleIcon="favorite"
      [layout]="filterSectionLayout"
      [newsType]="newsType"
      [filterItems]="homePageService.favoritesItems"
    ></lib-filter-section>

    <!-- State Leagues Section -->
    <lib-filter-section
      *ngIf="homePageService.selectedState"
      id="state-leagues-section"
      title="Top-Ligen"
      titleIcon="emoji_events"
      [layout]="filterSectionLayout"
      [newsType]="newsType"
      [filterItems]="homePageService.stateLeagueItems"
    ></lib-filter-section>

    <!-- National Leagues Section -->
    <lib-filter-section
      id="national-leagues-section"
      title="National"
      titleIcon="stadium"
      [layout]="filterSectionLayout"
      [newsType]="newsType"
      [filterItems]="homePageService.nationalLeagueItems"
    ></lib-filter-section>
    <lib-ad class="ad"></lib-ad>

    <!-- International Leagues Section -->
    <lib-filter-section
      *ngIf="!homePageService.selectedState"
      id="international-leagues-section"
      title="International"
      titleIcon="public"
      [layout]="filterSectionLayout"
      [newsType]="newsType"
      [filterItems]="homePageService.internationalLeagueItems"
    ></lib-filter-section>

    <lib-ad class="ad"></lib-ad>

    <!-- State Teams Section -->
    <lib-filter-section
      *ngIf="homePageService.selectedState"
      id="state-teams-section"
      title="Top-Teams"
      titleIcon="sports_soccer"
      [layout]="filterSectionLayout"
      [newsType]="newsType"
      [filterItems]="homePageService.stateTeamItems"
    ></lib-filter-section>

    <!-- States Section -->
    <div id="states-section">
      <lib-filter-section
        *ngIf="!homePageService.selectedState && this.stateSectionIntercepted"
        title="Aus den Bundesländern"
        titleIcon="grade"
        [layout]="filterSectionLayout"
        [filterItems]="homePageService.stateItems"
      ></lib-filter-section>
      <app-voucher-code-widget></app-voucher-code-widget>
    </div>
    <lib-ad class="ad"></lib-ad>
  </div>
</div>
